import React from 'react'
import MaterialSymbol from '../material-symbol'

const SupervisorAccount = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="supervisor_account" {...props} />
))

SupervisorAccount.displayName = 'SupervisorAccount'

export default SupervisorAccount
